import React from 'react';
import './newloader.css';

// Determine the primary color based on the environment variable
const is360 = process.env.REACT_APP_FINANZZ_URL === "360";
const primaryColor = is360 ? "#390098" : "#062533";

// Export the loader element with the dynamic color applied as a CSS custom property
export const spin = (
  <div className="newcontent">
    <div className="loader" style={{ '--loader-color': primaryColor }}></div>
  </div>
);

class NewLoader {
  // This class can remain empty or be used for future enhancements
}

export default NewLoader;